var React = require('react');

function WlLogoBig (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M100.3,3.1C47,3.1,3.8,46.3,3.8,99.6s43.2,96.5,96.5,96.5c53.3,0,96.5-43.2,96.5-96.5S153.6,3.1,100.3,3.1z\n\t M129.8,156.7h-1.1l-27.4-58.1l-27.4,58.1h-2.2L32.3,64.5h23l19.8,53.8l26.3-58.2h1.1l25.2,58.2l20.8-52.6h21.9L129.8,156.7z","style":{"fill":"#007AFF"}}));
}

WlLogoBig.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 200 200","style":{"enableBackground":"new 0 0 200 200"},"xmlSpace":"preserve","width":"20px","height":"20px"};

module.exports = WlLogoBig;

WlLogoBig.default = WlLogoBig;
